import React from 'react';
import { Row, Col } from 'antd';
import { I18n } from '@aws-amplify/core';
import * as S from '@/components/Settings/DataExtraction/styles';

interface HeaderProps {
	title?: string;
	description?: string;
	tooltip?: React.ReactNode;
}

export function Header({ title = '', description = '', tooltip }: Readonly<HeaderProps>) {
	return (
		<Row align="middle" gutter={[0, 8]}>
			{title && (
				<Col span={24}>
					<S.HeadingMediumSemibold>{I18n.get(title)}</S.HeadingMediumSemibold>
				</Col>
			)}
			{description && (
				<Col>
					<S.InlineParagraph>
						<S.BodyLargeRegular>{I18n.get(description)}</S.BodyLargeRegular>
						{tooltip && <S.TooltipWrapper>{tooltip}</S.TooltipWrapper>}
					</S.InlineParagraph>
				</Col>
			)}
		</Row>
	);
}
